import { Flex, NotificationsNoneOutlinedIcon, Text } from '@shared/components';

export default function NotificationNoRowOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        py: theme.spacing(20),
        alignItems: 'center',
        gap: theme.spacing(2),
        width: '100%',
      })}
    >
      <NotificationsNoneOutlinedIcon
        sx={(theme) => ({ fontSize: '100px', color: theme.palette.grey[400] })}
      />
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: theme.spacing(2),
        })}
      >
        <Text variant='h3'>ไม่มีการแจ้งเตือน</Text>
        <Text>ขณะนี้คุณไม่มีการแจ้งเตือนใหม่</Text>
      </Flex>
    </Flex>
  );
}
